export const initiateGlobalSession = () => ({
    type: 'INITIATE_GLOBAL_SESSION'
});

export const getApigeeToken = () => ({
    type: 'GET_APIGEE_TOKEN'
});

export const getZipcodes = (userInput, skipStreetUpdate) => ({
    type: 'GET_ZIPCODES',
    data: userInput,
    skipStreetUpdate
});

export const selectThisZipcode = (zipcode) => ({
    type: 'SAVE_SELECTED_ZIPCODE_AND_CHECK_IF_FIOS_QUALIFIED',
    data: zipcode
});

export const getStreetAddress = (userInput,isAutopayFlow=false) => ({
    type: 'GET_STREET_ADDRESS',
    data: userInput,
    isAutopayFlow
});

export const selectThisStreetAddress = (streetAddress) => ({
    type: 'SAVE_SELECTED_STREET_ADDRESS',
    data: streetAddress
});

export const getUnits = () => ({
    type: 'GET_UNITS'
});
export const getUnitsbyBillingAddress = (isAutoPayFlow={}) => ({
    type: 'GET_UNITS_BILLING_ADDRESS',
    data:isAutoPayFlow
});

export const saveUnitsforBillingAddress = (unit) => ({
    type: 'SAVE_UNITS_BILLING_ADDRESS',
    data :unit
});


export const getUnitsByUnitterm = (data) => ({
    type: 'GET_UNITS_BY_UNIT_TERM',
    data
});

export const selectThisUnit = (unit) => ({
    type: 'SAVE_SELECTED_UNIT',
    data: unit
});

export const showCheckAvailability = () => ({
    type: 'ENABLE_CHECK_AVAILABILITY'
});

export const savePhoneNumber = (phoneNumber) => ({
    type: 'SAVE_PHONE_NUMBER',
    data: phoneNumber
});

export const savePriceQuoteNumber = (priceQuoteNumber) => ({
    type: 'SAVE_PRICE_QUOTE_NUMBER',
    data: priceQuoteNumber
});

export const saveOptixMonNumber = (monNumber) => ({
    type: 'SAVE_OPTIX_MON_NUMBER',
    data: monNumber
})

export const saveEmailAddress = (emailAddress) => ({
    type: 'SAVE_EMAIL_ADDRESS',
    data: emailAddress
});

export const triggerAddressQualification = (historyObjectForNavigation) => {
    return ({
        type: 'TRIGGER_ADDRESS_QUALIFICATION',
        data: historyObjectForNavigation
    })
};

export const triggerOptixAddressQualification = (historyObjectForNavigation) => {
    return ({
        type: 'TRIGGER_OPTIX_ADDRESS_QUALIFICATION',
        data: historyObjectForNavigation
    })
};

export const toggleGlobalErrorMessage = (data) => ({
    type: 'TOGGLE_GLOBAL_ERROR_MESSAGE',
    data: data
});

export const clearGlobalStore = () => ({
    type: 'CLEAR_GLOBAL_STORE'
});

export const getFaqContent = (data) => ({
    type: "GET_FAQ_CONTENT",
    data: data
});

export const clearFaqContent = () => ({
    type: "CLEAR_FAQ_CONTENT"
});

export const saveConversationInfo = (data) => ({
    type: "SAVE_CONVERSATION_INFO",
    data: data
});

export const setConversationID = (data) => ({
    type: "SET_CONV_INFO",
    data: data
});


export const getMultipleAddrSelections = (data) => ({
    type: 'GET_MULTI_ADDR',
    data
});

export const saveCurrentLocation = (data) => ({
    type: 'SAVE_CURRENT_LOCATION',
    data
});

export const postEventLogging = (data) => ({
    type: 'POST_EVENT_LOGGING',
    data
});

export const setIsExternalAppRedirection = (data) => ({
    type: 'SET_IS_EXTERNALAPP_REDIRECT',
    data
});

export const selectThisUnitAddress = (unit) => ({
    type: 'SAVE_SELECTED_UNIT_ADDRESS',
    data: unit
});

export const currentLocationFetchError = (data) => ({
    type: 'FETCH_CURRENT_LOCATION_ERROR',
    data: data
});

export const useLocusApi = (data) => ({
    type: 'USE_LOCUS_API',
    data: data
});
export const setEmailValidation = (data) => ({
    type: 'SET_EMAIL_VALIDATION',
    data
});

export const validateEmail = (data) => ({
    type: 'VALIDATE_EMAIL',
    data
})
export const resetAddressSuggestionList = (data) => ({
    type: 'SAVE_STREET_ADDRESS_LIST',
    data
})